<div class="inicio">


  <form #insertForm="ngForm"  [formGroup]="formDetSolicitud" >

      <p class="titulo">SOLICITUD DE {{tipoSolicitud}} </p>
        <div class="grid-containerB" >
          <button mat-mini-fab style="background-color: #00c030d0;  color: white;" (click)="goBack()"> <span class="material-icons">undo</span> </button>
        </div>
      <div class="grid-container2">
        <div class="celda">
            <mat-label class="label" >Tipo de solicitud</mat-label>
            <mat-form-field appearance="outline">
                <input matInput type="text" placeholder="Tipo se solicitud" formControlName="tipoSolicitud" readonly/>
            </mat-form-field>
        </div>

      </div>
      <!--DATOS DEL COLABORADOR-->
      <p></p><h3>DATOS DEL COLABORADOR</h3>

      <div class="responsive-two-columns">
        <div><div class="div" >
          <!--Nombre del colaborador-->
          <div class="grid-container">
           <div class="celda">
               <mat-label class="label"> Nombre del colaborador </mat-label>
               <mat-form-field appearance="outline">
                   <input matInput type="text" placeholder="Nombre del colaborador" formControlName="colaborador" readonly />
               </mat-form-field>
           </div>
          </div>
           <!--Cargo-->
           <div class="celda">
               <mat-label class="label"> Cargo </mat-label>
               <mat-form-field appearance="outline">
                 <input matInput type="text" placeholder="No se encontró este campo" formControlName="puesto" readonly />
               </mat-form-field>
           </div>

           <!--Oficina/Sucursal-->
           <div class="celda">
               <mat-label class="label"> Sucursal </mat-label>
               <mat-form-field appearance="outline">
                   <input matInput type="text" placeholder="No se encontró este campo" formControlName="sucursal" readonly />
               </mat-form-field>
           </div>
         </div>
       </div>
        <div>
          <div class="div">
            <!--Sustituye a-->
           <div class="grid-container"  >
                 <mat-label class="label"> Sustituye a </mat-label>
                 <mat-form-field appearance="outline">
                   <input matInput type="text" placeholder="No se encontró este campo" formControlName="sustituye_a" readonly />
                 </mat-form-field>
           </div>
           <!--supervisor-->
           <div class="grid-container"  >
                 <mat-label class="label"> Nombre del supervisor </mat-label>
                 <mat-form-field appearance="outline">
                   <input matInput type="text" placeholder="Nombre del supervisor" formControlName="supervisor" readonly/>
                 </mat-form-field>
           </div>
       </div>
        </div>
    </div>

      <p></p>

       <!--DATOS DEL SOLICITANTE-->
       <p></p><h3>DATOS DEL SOLICITANTE</h3>
       <div class="div">
          <!--Nombre del colaborador-->
          <div class="grid-container">
           <div class="celda">
               <mat-label class="label"> Nombre del solicitante </mat-label>
               <mat-form-field appearance="outline">
                   <input matInput type="text" placeholder="No se encontró este campo" formControlName="solicitante" readonly />
               </mat-form-field>
           </div>
          </div>
         <!--Cargo y sucursal/oficina-->
         <div class="grid-container2">
           <!--Cargo-->
           <div class="celda">
               <mat-label class="label"> Cargo </mat-label>
               <mat-form-field appearance="outline">
                 <input matInput type="text" placeholder="No se encontró este campo" formControlName="puesto_solicitante" readonly/>
               </mat-form-field>
           </div>

           <!--Oficina/Sucursal-->
           <div class="celda">
               <mat-label class="label"> Sucursal </mat-label>
               <mat-form-field appearance="outline">
                   <input matInput type="text" placeholder="No se encontró este campo" formControlName="sucursal_solicitante" readonly />
               </mat-form-field>
           </div>
         </div>
          <!--email-->
          <div class="grid-container"  >
           <div class="celda"   >
               <mat-label  class="label"> Email </mat-label>
               <mat-form-field appearance="outline">
                 <input matInput type="text" placeholder="No se encontró este campo" formControlName="email_solicitante" readonly/>
               </mat-form-field>
           </div>
         </div>
       </div>
       <!--DATOS GNERALES DE LOS PRIVILEGIOS-->
       <p></p><h3 >DATOS GENERALES</h3>
      <div class="div" >

       <div class="div">
         <!--TABLAS DE SERVICIOS SOLICITADOS-->
          <div  class="grid-container" *ngIf=" statusSolicitud=='Espera' && banderaE !='true' "  >
              <div class="grid-container2"   >
                <div  class="celda"  >
                  <mat-label class="label"> AGREGAR SERVICIOS </mat-label>
                  <mat-form-field appearance="fill">
                    <mat-label > Seleccione los servicios que requiera </mat-label>
                    <mat-select formControlName="tipo_servicio" multiple>
                      <mat-option *ngFor="let servicio of listaServicios" [value]="servicio">{{servicio.nombre_servicio}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="celda" class="wrapper" >
                  <button type="submit" mat-raised-button color="primary" style="background-color: #00d836d0; width:350px; height:50px; color: white;"  (click)="generarDetalleSolicitud()" >Añadir servicios</button>
                </div>
              </div>

              <!--Servicio a solicitar alta de servicios-->

                <mat-label class="label" > SERVICIOS </mat-label>
              <div >
                <table mat-table [dataSource] = "dataSource" class="wrapper" class="mat-elevation-z8">

                  <ng-container matColumnDef="c1">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> NOMBRE DEL SERVICIO </th>
                      <td mat-cell *matCellDef="let element"> {{element.nombre_servicio}} </td>
                  </ng-container>
                  <ng-container matColumnDef="c2">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> USUARIO </th>
                    <td mat-cell *matCellDef="let element">
                      <mat-form-field>
                        <mat-label>Ingrese el usuario</mat-label> <!--[ngModelOptions]="{standalone: true}"-->
                        <input matInput (keydown.space)="$event.preventDefault();"  [(ngModel)]="element.usuario" [ngModelOptions]="{standalone: true}"  pattern="{{element.expresionRegular}}" >
                      </mat-form-field>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="c3">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> PASSWORD </th>
                    <td mat-cell *matCellDef="let element">
                      <mat-form-field>
                        <mat-label>Ingrese la contraseña</mat-label><!--[ngModelOptions]="{standalone: true}"-->
                        <input matInput (keydown.space)="$event.preventDefault();"  [(ngModel)]="element.contrasenia" [ngModelOptions]="{standalone: true}" >
                      </mat-form-field>
                    </td>
                  </ng-container>
                  <!--Selección de las sucursales-->
                  <ng-container matColumnDef="c4">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> SELECCIONE LA(S) SUCURSAL(ES) </th>
                    <td mat-cell *matCellDef="let element">
                      <mat-form-field appearance="fill">
                        <mat-label > Seleccione la o las sucursales </mat-label>
                        <mat-select [(ngModel)]="element.sucursales" [ngModelOptions]="{standalone: true}" multiple>
                          <mat-option *ngFor="let sucursal of listaSucursales" [value]="sucursal">{{sucursal.nombreSucursal}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </td>
                  </ng-container>
                  <!--Visualización de las sucursales seleccionadas-->
                  <ng-container matColumnDef="c5">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> LISTA DE SUCURSALES </th>
                    <td mat-cell *matCellDef="let element"> {{this.leerSucursales(element.sucursales)}}</td>
                  </ng-container>
                  <ng-container matColumnDef="c6">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{cabeceraCheck}} SERVICIO </th>
                    <td mat-cell *matCellDef="let element">
                        <mat-checkbox [(ngModel)]="element.status_reg" [ngModelOptions]="{standalone: true}"  ></mat-checkbox>
                        <span *ngIf="element.status_reg==true" ></span>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="encabezadostabla"></tr>
                  <tr mat-row *matRowDef="let row; columns: encabezadostabla;"></tr>
                  <h2></h2>

                </table>
              </div>
              <p></p>


          </div> <!--CIERRE DE LAS TABLAS DE SERVICIOS SOLICITADOS-->

        <!--DETALLE DE LOS SERVICIOS DE UNA SOLICITUD ATENDIDA  -->
        <div class="grid-tabla" *ngIf="statusSolicitud=='Atendido' || statusSolicitud=='Cancelado' || banderaE=='true' "  >
          <mat-label class="label"> SERVICIOS </mat-label>
          <br>
             <!--Tabla-->
          <table mat-table [dataSource] = "dataAtendidos"  class="mat-elevation-z8">
            <ng-container matColumnDef="c1">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> NOMBRE DEL SERVICIO </th>
                <td mat-cell *matCellDef="let element"> {{element.nombre_servicio}} </td>
            </ng-container>
            <ng-container matColumnDef="c2">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> ESTATUS DEL SERVICIO </th>
              <td mat-cell *matCellDef="let element"> {{element.status_serv}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="encabezadostabAtendidos"></tr>
            <tr mat-row *matRowDef="let row; columns: encabezadostabAtendidos;"></tr>
          </table>
        </div>

        <br> <br> <br>
        <!--TABLA DE SERVICIOS DADOS DE ALTA SOLICITUD ANTENDIDA-->
        <div class="grid-tabla" *ngIf="statusSolicitud=='Atendido'" >
          <mat-label class="grid-container" class="label"  > SERVICIOS ACTIVADOS DE ESTA SOLICITUD</mat-label>
          <p></p>
          <table mat-table [dataSource] = "dataServAlta"  class="mat- elevation-z8">

            <ng-container matColumnDef="c1">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> NOMBRE DEL SERVICIO </th>
                <td mat-cell *matCellDef="let element"> {{element.detalleSolicitud.tipo_servicio.nombre_servicio}} </td>
            </ng-container>
            <ng-container matColumnDef="c2">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> USUARIO </th>
              <td mat-cell *matCellDef="let element">  <mat-form-field>
                <mat-label>Ingrese el usuario</mat-label> <!--[ngModelOptions]="{standalone: true}"-->
                <input matInput (keydown.space)="$event.preventDefault();"  [(ngModel)]="element.usuario" [ngModelOptions]="{standalone: true}"  pattern="{{element.expresionRegular}}" >
              </mat-form-field></td>
            </ng-container>
            <ng-container matColumnDef="c3">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> PASSWORD </th>
              <td mat-cell *matCellDef="let element"> <mat-form-field>
                        <mat-label>Ingrese la contraseña</mat-label><!--[ngModelOptions]="{standalone: true}"-->
                        <input matInput (keydown.space)="$event.preventDefault();"  [(ngModel)]="element.contrasenia" [ngModelOptions]="{standalone: true}" >
                      </mat-form-field>  </td>
            </ng-container>
            <ng-container matColumnDef="c4">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> SUCURSAL </th>
              <td mat-cell *matCellDef="let element">
                <mat-form-field>
                  <mat-label>SUCURSAL:</mat-label>
                  <mat-select   [(ngModel)]="element.idSucursal" [ngModelOptions]="{standalone: true}" >
                    <mat-option *ngFor="let title of listaSucursales" [value]="title.idSucursal">
                      {{ title.nombreSucursal }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </td>
            </ng-container>

            <ng-container matColumnDef="c5">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> EDITAR </th>
              <td mat-cell *matCellDef="let element">
                <button mat-mini-fab color="accent" aria-label="Example icon button with a plus one icon" (click)="update(element)">
                <mat-icon>edit</mat-icon>
              </button> </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="encabezadostabla4"></tr>
            <tr mat-row *matRowDef="let row; columns: encabezadostabla4;"></tr>
            <h2></h2>
          </table>
          <br>
        </div>
          <!--Fecha de asignación-->
          <div class="celda">
            <mat-label class="label">Fecha de asignación</mat-label>
            <mat-form-field appearance="outline">
                <input matInput type="text" placeholder="No se encontró este campo" formControlName="fecha_planeada" readonly />
            </mat-form-field>
          </div>
          <P></P>
          <!--Comentarios-->
          <div class="grid-container">
              <div class="celda">
                  <mat-label class="label">Comentarios</mat-label>
                  <mat-form-field class="example-full-width" appearance="outline">
                      <textarea matInput placeholder="Comentarios" formControlName="comentarios" readonly  ></textarea>
                  </mat-form-field>
              </div>
          </div>
        </div>
      </div>
      <p></p>
      <!--Botones-->
      <div class="grid-container2" *ngIf="statusSolicitud=='Espera' && banderaE !='true' ">
        <!--Boton guaradar-->
        <button  type="submit" mat-raised-button color="primary"  (click)="agregarServicio()" >Aceptar</button>
        <!--Boton cancelar-->
        <button mat-raised-button color="warn" (click)="rechazarSolicitud()" >Rechazar solicitud<mat-icon>cancel</mat-icon></button>
      </div>
      <div class="wrapper" *ngIf="statusSolicitud=='Atendido' || statusSolicitud=='Cancelado' || banderaE=='true' " >
        <button mat-raised-button style="background-color: #00c030d0; width:350px; color: white;" (click)="goBack()" >Aceptar<mat-icon>done_all</mat-icon></button>
      </div>

  </form>
</div>
